export default {
  title: "Language Education for Children and Teens at Home",

  features: [
    "20 years of experience teaching children and teenagers",
    "Gold Medal winner at Canada’s iCAN Educational Festival",
    "Recognized by the International Federation of Inventors' Associations in the United States for education",
  ],

  description:
    "The founder of this educational collection is Mr. Mohammad Khaled Feyzi, author of the Joy Phonics books. All educational scenarios are written by him.",
};
